import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={34}
    height={32}
    viewBox="0 0 34 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7621 12.864C21.6495 12.858 21.5361 12.8573 21.4221 12.8573C17.3506 12.8573 14.0483 15.4607 14.0483 18.674C14.0483 19.2 14.1397 19.7093 14.3055 20.194C13.2593 20.2518 12.2102 20.1473 11.2001 19.8847L11.0627 19.8473L8.13588 21.25L8.91788 18.9447L8.84421 18.9C6.91188 17.736 5.66663 15.902 5.66663 13.8387C5.66663 10.3193 9.29046 7.46667 13.7615 7.46667C17.811 7.46667 21.1664 9.80667 21.7621 12.864ZM10.9444 12.68C10.3168 12.68 9.80754 12.2153 9.80754 11.644C9.80754 11.0713 10.3168 10.6087 10.9444 10.6087C11.5727 10.6087 12.0827 11.0713 12.0827 11.644C12.0827 12.2153 11.5727 12.68 10.9444 12.68ZM16.5785 10.6087C17.2061 10.6087 17.7147 11.0713 17.7147 11.644C17.7147 12.2153 17.2061 12.68 16.5785 12.68C15.9502 12.68 15.4423 12.2153 15.4423 11.644C15.4423 11.0713 15.9502 10.6087 16.5785 10.6087Z"
      fill="#45B035"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4838 24.0947C17.7063 24.0947 14.6434 21.6847 14.6434 18.7113C14.6434 15.7393 17.7063 13.3293 21.4838 13.3293C25.2592 13.3293 28.3214 15.7393 28.3214 18.7113C28.3214 20.4553 27.2681 22.0047 25.6368 22.9887L25.5737 23.0253L26.2346 24.974L23.7632 23.7873C23.7632 23.7873 23.6853 23.81 23.6463 23.8193C22.9421 24.0032 22.2146 24.0958 21.4838 24.0947ZM18.1426 16.8573C18.1426 16.3747 18.5733 15.9827 19.1031 15.9827C19.6343 15.9827 20.0643 16.3747 20.0643 16.8573C20.0643 17.3413 19.6336 17.734 19.1031 17.734C18.5733 17.734 18.1426 17.3413 18.1426 16.8573ZM22.9026 16.8573C22.9026 16.3747 23.3311 15.9827 23.8617 15.9827C24.3929 15.9827 24.8222 16.3747 24.8222 16.8573C24.8222 17.3413 24.3929 17.734 23.8617 17.734C23.3318 17.734 22.9019 17.3413 22.9019 16.8573H22.9026Z"
      fill="#45B035"
    />
  </svg>
);
export default SVGComponent;
